import { queryOptions } from "@tanstack/react-query";
import { type ColumnFiltersState } from "@tanstack/react-table";
import { useAppSelector } from "../../../../redux/hooks";
import { apiClient } from "../../../../zodios/client";
import { useDates } from "../../../../dates/DatesContext";
import { adaptFilters } from "./utils";
import moment from "moment";

type Params = {
  filters?: ColumnFiltersState;
  search?: string;
};

export const useGetV4ProductReportByDate = () => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const { start, end, group, preStart, preEnd } = useDates();
  return (params: Params) => {
    const search = params.search ? params.search.split(",") : [];
    const filters = adaptFilters(params);
    return queryOptions({
      queryKey: [
        { entity: "V4ProductReportByDate", marketPlace, params, dates: { start, end, preStart, preEnd, group } },
      ],
      queryFn: async () => {
        const res = await apiClient.getV4ProductReportByDate({
          queries: {
            marketplace: marketPlace,
            start_date: start.format("YYYY-MM-DD"),
            end_date: end.format("YYYY-MM-DD"),
            start_date_previous: preStart.format("YYYY-MM-DD"),
            end_date_previous: preEnd.format("YYYY-MM-DD"),
            // TODO fix typing
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            filters: filters as any,
            date_group: group,
            search,
          },
        });
        return res;
      },
    });
  };
};

export const useGetV4ProductReportByDateOpen = ({ start, end }: { start: Date; end: Date }) => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  return queryOptions({
    queryKey: [
      {
        entity: "V4ProductReportByDate",
        marketPlace,
        dates: { start, end, preStart: start, preEnd: start, group: "day" },
      },
    ],
    queryFn: async () => {
      const res = await apiClient.getV4ProductReportByDate({
        queries: {
          marketplace: marketPlace,
          start_date: moment(start).format("YYYY-MM-DD"),
          end_date: moment(end).format("YYYY-MM-DD"),
          start_date_previous: moment(start).format("YYYY-MM-DD"),
          end_date_previous: moment(start).format("YYYY-MM-DD"),
          date_group: "day",
        },
      });
      return res;
    },
  });
};
